import { ReactNode } from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { ForceChangePasswordDialog } from "./ForceChangePasswordDialog";
import { IdleTimeoutDialog } from "./IdleTimeoutDialog";
import { useIdleTimeout } from "../hooks/useIdleTimeout";

/** Redirects to /login if no session. Renders force-change dialog if needed. */
export function ProtectedRoute({ children }: { children: ReactNode }) {
  const { session, loading, mustChangePassword } = useAuth();
  const { warning, secondsRemaining, staySignedIn } = useIdleTimeout();

  if (loading) {
    return (
      <div className="flex h-screen items-center justify-center text-cream-400">
        Loading…
      </div>
    );
  }
  if (!session) {
    return <Navigate to="/login?reason=session-expired" replace />;
  }

  const content = (
    <>
      {children}
      <IdleTimeoutDialog
        open={warning}
        secondsRemaining={secondsRemaining}
        onStaySignedIn={staySignedIn}
      />
    </>
  );

  if (mustChangePassword) {
    return (
      <div aria-hidden={false} style={{ pointerEvents: "auto" }}>
        {content}
        <ForceChangePasswordDialog />
      </div>
    );
  }
  return content;
}
